import { create } from 'zustand';
import { getAiCredits } from '@/api/ai';

interface AiCredits {
  used: number;
  limit: number;
  month: string;
  hasByokKey: boolean;
}

export interface AiState {
  credits: AiCredits | null;
  isLoading: boolean;
  fetchCredits: () => Promise<void>;
}

export const useAiStore = create<AiState>((set) => ({
  credits: null,
  isLoading: false,

  fetchCredits: async () => {
    set({ isLoading: true });
    try {
      const credits = await getAiCredits();
      set({ credits, isLoading: false });
    } catch {
      set({ isLoading: false });
    }
  },
}));
